import { Box, Divider, Grid } from "@mui/material";
import { MenusProps } from "../";
import { escurecerCor } from "../../../../helpers/manipulacaoCores";
import { colors } from "../../bannerColors";
import TemplateOpcoes from "../../Templates/TemplateOpcoes";
import AddIcon from "@mui/icons-material/Add";
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import { useNavigate } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import TemplateDashboardComOpcoes from "../../Templates/TemplateDashboardComOpcoes";
import { useModalStateContext } from "../../../../contexts/ModalStateContext";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { usePermission } from "../../../PermissionGuard";

export default function FinanceiroMenu({ type }: MenusProps) {
  const navigate = useNavigate();

  const color = colors[type] || "#1E2E6B";
  const textColor = escurecerCor(color);

  const handleRedirect = (path: string) => {
    navigate(`/financeiro/${path}`);
  };

  const { handleToggleModal } = useModalStateContext();

  return (
    <Box>
      <Grid container spacing={2}>
        <TemplateDashboardComOpcoes
          {...{ type }}
          color={textColor}
          items={[
            {
              label: "Configurações",
              icon: <SettingsIcon fontSize="inherit" />,
              action: () => handleRedirect("configuracoes"),
              disabled: !usePermission("financeiro.configuracoes"),
            },
            {
              label: "Integrações bancárias",
              icon: <CurrencyExchangeIcon fontSize="inherit" />,
              action: () => handleRedirect("integracoes-bancarias"),
              disabled: !usePermission("financeiro.integracoes-bancarias"),
            },
          ]}
        />

        <Divider
          orientation="vertical"
          sx={{ border: "1px solid", borderColor: "divider" }}
          flexItem
        />

        <Grid container  size={{md: 2.4}} spacing={2} alignSelf="flex-start">
          <TemplateOpcoes
            title="Contas a receber"
            color={textColor}
            items={[
              {
                label: "Incluir título a receber",
                icon: <AddIcon fontSize="inherit" />,
                action: () => {
                  handleToggleModal("financeiro", "incluirRecebimento", true);
                },
                disabled: !usePermission('financeiro.incluir-titulo-receber'),
              },
              {
                label: "Listar todas",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("contas-receber/listar-todas"),
                disabled: !usePermission('financeiro.listar-titulo-receber'),
              },
              {
                label: "Registrar recebimento",
                icon: <PaidOutlinedIcon fontSize="inherit" />,
                action: () =>
                  handleToggleModal("financeiro", "registrarRecebimento", true),
                disabled: !usePermission('financeiro.registrar-recebimento'),
              },
              {
                label: "Listar recibos",
                icon: <PlaylistAddCheckIcon fontSize="inherit" />,
                action: () => handleRedirect("contas-receber/listar-recibos"),
                disabled: !usePermission('financeiro.listar-recibos'),
              },
              {
                label: "Recebimentos e baixas",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("contas-receber/listar-recebimentos-baixas"),
                disabled: !usePermission('financeiro.contas-receber-listar-recebimentos-baixas'),
              },
            ]}
          />

          <TemplateOpcoes
            title="Limite de crédito"
            color={textColor}
            items={[
              {
                label: "Abrir solicitação",
                icon: <AddIcon fontSize="inherit" />,
                action: () => handleToggleModal("financeiro", "solicitarAnaliseCredito", true),
                disabled: !usePermission('financeiro.limite-credito'),
              },
              {
                label: "Listar solicitações",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("limite-credito/lista-todas"),
                disabled: !usePermission('financeiro.limite-credito-listar'),
              },
              {
                label: "Atualização de limites",
                icon: <AttachMoneyIcon fontSize="inherit" />,
                action: () =>
                  handleToggleModal("financeiro", "atualizacaoCredito", true),
                disabled: !usePermission('financeiro.limite-credito-atualizar-limites'),
              },
            ]}
          />
        </Grid>

        <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">
          <TemplateOpcoes
            title="Contas a pagar"
            color={textColor}
            items={[
              {
                label: "Incluir título a pagar",
                icon: <AddIcon fontSize="inherit" />,
                action: () =>
                  handleToggleModal("financeiro", "incluirPagamento", true),
                disabled: !usePermission('financeiro.incluir-titulo-pagar'),
              },
              {
                label: "Listar todas",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("contas-pagar/listar-todas"),
                disabled: !usePermission('financeiro.listar-titulo-pagar'),
              },
              {
                label: "Registrar pagamento",
                icon: <CreditCardOutlinedIcon fontSize="inherit" />,
                action: () =>
                  handleToggleModal("financeiro", "registrarPagamento", true),
                disabled: !usePermission('financeiro.registrar-pagamento'),
              },
              {
                label: "AP Global",
                icon: <MonetizationOnIcon fontSize="inherit" />,
                action: () => handleToggleModal("financeiro", "apGlobal", true),
                disabled: !usePermission('financeiro.ap-global'),
              },
            ]}
          />

          <TemplateOpcoes
            title="Conta consumo"
            color={textColor}
            items={[
              {
                label: "Visão geral",
                icon: <DashboardOutlinedIcon fontSize="inherit" />,
                action: () =>
                  handleRedirect("conta-corrente-consumo/visao-geral"),
                disabled: !usePermission('financeiro.cco-visualizar'),
              },
              {
                label: "Incluir lançamentos",
                icon: <AddIcon fontSize="inherit" />,
                action: () =>
                  handleToggleModal("financeiro", "incluirLancamentoCCO", true),
                disabled: !usePermission('financeiro.cco-incluir-lancamento'),
              },
            ]}
          />
        </Grid>

        <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">
          <TemplateOpcoes
            title="Caixa e bancos"
            color={textColor}
            items={[
              {
                label: "Incluir lançamento",
                icon: <AddIcon fontSize="inherit" />,
                action: () =>
                  handleToggleModal(
                    "financeiro",
                    "incluirLancamentoCaixaBanco",
                    true
                  ),
                disabled: !usePermission('financeiro.caixa-bancos-incluir-lancamento'),
              },
              {
                label: "Incluir transferência",
                icon: <AddIcon fontSize="inherit" />,
                action: () => { },
                disabled: true,
              },
              {
                label: "Extrato de contas",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("caixa-bancos/extrato-contas"),
                disabled: !usePermission('financeiro.caixa-bancos-extrato-contas'),
              },
              {
                label: "Listar lançamentos",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("caixa-bancos/listar-lancamentos"),
                disabled: !usePermission('financeiro.caixa-bancos-listar-lancamentos'),
              },
            ]}
          />

          <TemplateOpcoes
            title="Cupons e descontos"
            color={textColor}
            items={[
              {
                label: "Adicionar cupom",
                icon: <AddIcon fontSize="inherit" />,
                action: () =>
                  handleToggleModal(
                    "financeiro",
                    "adicionarCupom",
                    true
                  ),
                disabled: !usePermission('financeiro.cupons-adicionar-cupom'),
              },
              {
                label: "Listar cupons",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("cupons/listar-todos"),
                disabled: !usePermission('financeiro.cupons-listar'),
              },
            ]}
          />
        </Grid>

        <Grid container size={{md: 2.3}} spacing={2} alignSelf="flex-start">
          <TemplateOpcoes
            title="Cheques"
            color={textColor}
            items={[
              {
                label: "Incluir cheque",
                icon: <AddIcon fontSize="inherit" />,
                action: () =>
                  handleToggleModal("financeiro", "incluirCheque", true),
                disabled: !usePermission('financeiro.cheques-incluir-cheque'),
              },
              {
                label: "Listar cheques",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("cheques/listar-cheques"),
                disabled: !usePermission('financeiro.cheques-listar-cheques'),
              },
              {
                label: "Listar cheques devolvidos",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () =>
                  handleRedirect("cheques/listar-cheques-devolvidos"),
                disabled: !usePermission('financeiro.cheques-listar-cheques-devolvidos'),
              },
            ]}
          />
          <TemplateOpcoes
            title="Fluxo de Caixa"
            color={textColor}
            items={[
              {
                label: "Listagem de simulações",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () =>
                 handleRedirect("fluxo-caixa/listar-simulacoes"),
                disabled: !usePermission('financeiro.fluxo-caixa-listar-simulacoes'),
              },
              {
                label: "Adicionar simulação",
                icon: <AddIcon fontSize="inherit" />,
                action: () =>
                  handleToggleModal(
                    "financeiro",
                    "gerarSimulacao",
                    true
                  ),
                disabled: !usePermission('financeiro.fluxo-caixa-gerar-simulacao'),
              },
            ]}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
